/* ==========================================================================
   VPV CART — small enhancements for the side cart + cart page.

   Count pluralization: the header shows "<n> Product(s)". theme.js updateCount()
   rewrites only the number (.cart__count) on every cart build, leaving the word
   stale, so we watch the number and keep the label ("Product" vs "Products") in
   sync. Isolated file (loaded from theme.liquid) to avoid clobbering other work.
   ========================================================================== */
(function () {
  var COUNT_SELECTOR = '.cart-drawer__count, .cart-page__count';

  function syncLabel(container) {
    var num = container.querySelector('.cart__count');
    var label = container.querySelector('.cart__count-label');
    if (!num || !label) return;
    var n = parseInt(num.textContent.trim(), 10);
    if (isNaN(n)) return;
    label.textContent = n === 1 ? 'Product' : 'Products';
  }

  function init() {
    var containers = document.querySelectorAll(COUNT_SELECTOR);
    if (!containers.length || typeof MutationObserver === 'undefined') return;

    containers.forEach(function (container) {
      syncLabel(container);
      var num = container.querySelector('.cart__count');
      if (!num) return;
      new MutationObserver(function () {
        syncLabel(container);
      }).observe(num, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
